import React from 'react';
import { observer } from 'mobx-react-lite';
import { Helmet } from 'react-helmet';

import { useStores } from '../../hooks';
import AdminLayout from './AdminLayout';

const Dashboard = () => {
  const {
    DashboardStore: { setProperty },
  } = useStores();

  setProperty('onDashboardScreen', true);

  return (
    <React.Fragment>
      <Helmet>
        <title>Simulcast - Portal</title>
      </Helmet>
      <AdminLayout />
    </React.Fragment>
  );
};

export default observer(Dashboard);
